import React, { FC } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'

import { SellerList } from './SellerList'
import { SellerEdit } from './SellerEdit'

interface Props {

}

export const SellerPage: FC<Props> = () => {
    const { path } = useRouteMatch()

    return (
        <Switch>
            <Route exact path={path} component={SellerList}/>
            <Route exact path={`${path}/edit/:id`} component={SellerEdit}/>
        </Switch>
    )
}